import { useMutation } from "@tanstack/react-query"
import { AcquisitionModeInFlightplan } from "../models/AcquisitionMode"
import { FlightPlannedLineType, FlightplanType } from "../store/types/FlightPlansTypes"
import { API } from "./API"

export interface FlightplanCreateDto {
    flight_plan: FlightplanType
    flight_planned_lines: FlightPlannedLineCreateDto[]
    acquisition_modes: AcquisitionModeInFlightplan[]
}

export interface FlightplanUpdateDto extends FlightplanType {
    deleted_lines: number[]
    acquisition_modes: AcquisitionModeInFlightplan[]
}

export interface FlightPlannedLineCreateDto extends Omit<FlightPlannedLineType, "planned_line_id"> {
    planned_line_id?: number
}

export const useCreateFlightplan = () => {
    return useMutation({
        mutationFn: async (flightplan: FlightplanCreateDto): Promise<void> => {
            await API.post("/flightplan/0", flightplan, "Error creating new flightplan.")
        },
    })
}

export const useUpdateFlightplan = () => {
    return useMutation({
        mutationFn: async (flightplan: FlightplanUpdateDto): Promise<void> => {
            await API.put(`/flightplan/${flightplan.flight_plan_id}`, flightplan, "Error updating flightplan.")
        },
    })
}

export const useDeleteFlightplan = () => {
    return useMutation({
        mutationFn: async (flightplanId: number): Promise<void> => {
            await API.delete(`/flightplan/${flightplanId}`, `Error deleting flightplan with id ${flightplanId}.`)
        },
    })
}
